// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement } from 'react';
import './qualificationsTechnicalTDT.scss';
import { useTranslation } from 'react-i18next';

import useCheckColor from 'store/hooks/useCheckColor';
import { TechnicalTDTModel } from 'api/types/Technical';

interface Props {
  userId: number | null;
  dataTechnicalTDT: TechnicalTDTModel[] | null | undefined;
}

const QualificationsTechnicalTDT = (props: Props): ReactElement => {
  const { userId, dataTechnicalTDT } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  return (
    <>
      {dataTechnicalTDT &&
      dataTechnicalTDT !== null &&
      Object.keys(dataTechnicalTDT)?.length > 0 ? (
        <Box
          id="userTechnicalTDTBox"
          name={t('userTechnicalTDT.technicalTDT')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userTechnicalTDTContent">
            {Object.keys(dataTechnicalTDT)?.map((k) => (
              <DesktopItem
                id="qualifications"
                name={dataTechnicalTDT?.[k]?.qualification?.description}
              >
                <>
                  {dataTechnicalTDT?.[k]?.qualificationNumber !== null &&
                  dataTechnicalTDT?.[k]?.qualificationNumber !== ' ' &&
                  dataTechnicalTDT?.[k]?.qualificationNumber !== '' ? (
                    <div className="technicalTDTDetailBox">
                      <div className="technicalTDTLabel">
                        {t('userTechnicalTDT.qualificationNumber')}
                      </div>
                      <div className="technicalTDTValue">
                        {dataTechnicalTDT?.[k]?.qualificationNumber}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataTechnicalTDT?.[k]?.expirationQualificationDate !==
                  null ? (
                    <div
                      className={`dateTechnicalTDTBox ${checkColor(
                        dataTechnicalTDT?.[k]?.expirationQualificationDate,
                        'uprawnienia',
                        'udt'
                      )}`}
                    >
                      <div
                        className={`dateTechnicalTDTLabel ${checkColor(
                          dataTechnicalTDT?.[k]?.expirationQualificationDate,
                          'uprawnienia',
                          'udt'
                        )}`}
                      >
                        {t('userTechnicalTDT.expirationQualificationDate')}
                      </div>
                      <div
                        className={`dateTechnicalTDTValue ${checkColor(
                          dataTechnicalTDT?.[k]?.expirationQualificationDate,
                          'uprawnienia',
                          'udt'
                        )}`}
                      >
                        {dataTechnicalTDT?.[k]?.expirationQualificationDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="borderTop" />
                </>
              </DesktopItem>
            ))}
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default QualificationsTechnicalTDT;
